<template lang="pug">
section.v-page-section.page-section(v-if="section")
	//-v-loader(:loading="loading")
	.container(v-if="!loading")
		v-page-section-header(:data-source="section")
		slot
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [sourceMixin],

	data() {
		return {
			section: null
		};
	},

	methods: {
		dataSet(data) {
			this.section = data;
		}
	}
};
</script>